<template>
  <v-container class="fill-height" fluid>
    <v-row no-gutters align="center" justify="center">
      <v-col cols="12" class="display-4 error--text text-center">
        500
      </v-col>
      <v-col cols=12 class="subtitle-1 grey--text text-center">
        A apărut o eroare, încearcă mai târziu.
      </v-col>
<!--      <v-col cols=12 class="text-center mt-5">-->
<!--        <v-btn text class="primary" @click="goBack()">Înapoi</v-btn>-->
<!--      </v-col>-->
    </v-row>
  </v-container>
</template>

<script>

  export default {
    mounted() {
      document.title = '500 - Internal server error.';
    },

    // methods: {
    //   goBack() {
    //     this.$router.push('/hotel');
    //   }
    // }
  }


</script>